import Const from './const'

function getKey(key) {
	return Const.DATA.KEY_PREFIX + key;
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
	name = getKey(name);
	return window.localStorage.setItem(name, JSON.stringify(content));
};

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
	name = getKey(name);
	return JSON.parse(window.localStorage.getItem(name));
};

export function setToken(val) {
	let key = Const.DATA.KEY_TOKEN;
	return setStore(key, val);
}

export function getToken() {
	let key = Const.DATA.KEY_TOKEN;
	return getStore(key);
}